import { render, staticRenderFns } from "./CPDueDiligenceGeneralDetails.vue?vue&type=template&id=331fef22&scoped=true&"
import script from "./CPDueDiligenceGeneralDetails.vue?vue&type=script&lang=ts&"
export * from "./CPDueDiligenceGeneralDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "331fef22",
  null
  
)

export default component.exports